"use client";

import { memo } from "react";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";

export interface DonationSuccessStepProps {
  operationCode: string | null;
  donationId?: number | null;
  onClose: () => void;
  t: (key: string) => string;
  title?: string;
  message?: string;
}

function DonationSuccessStepComponent({
  operationCode,
  donationId,
  onClose,
  t,
  title,
  message,
}: DonationSuccessStepProps) {
  const displayId = donationId ? `#${donationId}` : operationCode;

  return (
    <div className="flex flex-col items-center justify-center py-8">
      <CheckCircle className="h-16 w-16 text-green-500 mb-4" />
      <h3 className="text-xl font-bold text-green-600 mb-2">
        {title || t("checkout.successMessage")}
      </h3>
      {message ? (
        <p className="text-sm text-muted-foreground text-center mb-2">{message}</p>
      ) : null}
      {displayId && (
        <div className="mt-1 inline-flex items-center gap-2 rounded-lg border bg-muted/40 px-4 py-2">
          <span className="text-sm text-muted-foreground">
            {t("donation.operationCode")}
          </span>
          <span className="font-mono text-lg font-bold text-primary tracking-wide">
            {displayId}
          </span>
        </div>
      )}
      <Button onClick={onClose} className="mt-6">
        {t("common.close")}
      </Button>
    </div>
  );
}

export const DonationSuccessStep = memo(DonationSuccessStepComponent);
